export default __webpack_public_path__ + "static/media/circle_stop.2227cb10.svg";